import SnowplowAnon from "@common/components/thirdParty/snowplowanon";
import { ReactElement, useCallback, useEffect, useState } from "react";
import Hotjar from "../hotjar";
import Snowplow from "@common/components/thirdParty/snowplow";
import VWO from "../vwo";
import GDPRCookieNotice from "../passatgt";
import { GDPRProvider, useGDPRStore } from "@stores/gdpr";
import { useRouter } from "next/router";
import { useAccount } from "@stores/session/hooks";
import { isProduction } from "@common/utils/config";
import ProductAnalytics from "@common/components/thirdParty/metabase/ProductAnalytics";
import Script from "next/script";

export default function Tracking(): ReactElement {
  return (
    <GDPRProvider>
      <TrackingContent />
    </GDPRProvider>
  );
}

function TrackingContent(): ReactElement {
  const { marketing, analytics, status } = useGDPRStore();

  // session
  const account = useAccount();

  // page url
  const [previousPageUrl, setPreviousPageUrl] = useState<string>();
  const onRouteChangeStart = useCallback(() => {
    setPreviousPageUrl(window.location.href);
  }, []);
  const router = useRouter();
  useEffect(() => {
    router.events.on("routeChangeStart", onRouteChangeStart);
    return () => {
      router.events.off("routeChangeStart", onRouteChangeStart);
    };
  }, [router.events, onRouteChangeStart]);

  return (
    <>
      <SnowplowAnon />

      {marketing && (
        <>
          {isProduction() && (
            <>
              <Script
                id="ad-tracking-gtm-init"
                dangerouslySetInnerHTML={{
                  __html: `
                    (function(w,l){
                      w[l]=w[l]||[];
                      w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
                    })(window,'dataLayer');
                  `,
                }}
              />
              <Script
                id="ad-tracking-gtm"
                src={`https://www.googletagmanager.com/gtm.js?id=${process.env.AD_TRACKING_GTM}`}
              />
            </>
          )}
          <Hotjar />
          <Snowplow
            initCallsArgs={[
              "'enableActivityTracking', 10, 10",
              "'enableLinkClickTracking'",
            ]}
            referrerUrl={previousPageUrl || document.referrer}
            account={account}
          />
          <VWO />
        </>
      )}

      {isProduction() && status !== "pending" && (
        <ProductAnalytics
          haveConsent={analytics}
          tag="store"
          user={account}
          persistence={analytics}
        />
      )}

      <GDPRCookieNotice />
    </>
  );
}
